import React, { useState, useCallback } from 'react';

import {
    required, minLength, maxLength, minValue, maxValue,
    number, regex, email, choices,
    TabbedForm, FormTab, DeleteButton, useRefresh, AutocompleteInput,
    Edit, SimpleForm, TextInput, RichTextField,
    ReferenceInput, SelectInput, EditButton, NumberField,
    DateInput, BooleanInput, NumberInput, ImageInput, ImageField,
    ReferenceManyField, ReferenceField, Datagrid, TextField, BooleanField, FormDataConsumer
} from 'react-admin';
import { useForm } from 'react-final-form';
import { useStyles } from "../../formStyles";
import { Button } from '@material-ui/core';
import * as apiClient from "../../common/apiClient";
export const CustomButton = ({ formData
    , ...rest }) => {
    const form = useForm();
    const classes = useStyles({});
    const handleAddOneYear = () => {
        if (formData.policyStartDate) {
          const startDate = new Date(formData.policyStartDate);
          const endDate = new Date(startDate);
          endDate.setFullYear(endDate.getFullYear() + 1);
          endDate.setDate(endDate.getDate() - 1);
      
          
          const yyyy = endDate.getFullYear();
          const mm = String(endDate.getMonth() + 1).padStart(2, '0');
          const dd = String(endDate.getDate()).padStart(2, '0');
          const formattedDate = `${yyyy}-${mm}-${dd}`;
      
          form.change('policyEndDate', formattedDate);
        }
      };
      

    return (
        <div className="address-field-parent"> 
         <Button style={{ width: 200,margin:10 }} onClick={handleAddOneYear} variant="outlined" color='primary'>
                            Get End Date
                          </Button>

            
            </div>
        
    )
}
